import React from 'react';
import { TopoLines } from './TopoLines';
type Tome = {
  number: string;
  title: string;
  meetings: string;
  promise: string;
  band: string;
  ink: string;
  contents: string[];
};
const tomes: Tome[] = [{
  number: '01',
  title: 'The Diagnostic Toolkit & Safe Service Visit',
  meetings: '26 cards · 7 WS',
  promise: 'The method and the measurements that work on any system.',
  band: 'bg-vol-1',
  ink: 'text-white',
  contents: ['Triage from the monitoring portal before you roll the truck', 'The Safe-Approach Sequence: AC, DC, battery, verify', 'Voc against the temperature-corrected label, current with a DC clamp, polarity', 'Insulation test setup, IV curve tracing and thermal imaging basics', 'Catch intermittent faults and run the final production check']
}, {
  number: '02',
  title: 'The Array: Modules, Strings, Wiring & Mounting',
  meetings: '27 cards · 6 WS',
  promise: 'Rule out the array before you blame the box.',
  band: 'bg-vol-2',
  ink: 'text-pine',
  contents: ['One string low, whole array low, shading, soiling and degradation', 'Hot spots, bypass diodes, cracked cells and PID', 'Ground-Fault Halving: find the leg, the string and the run', 'Arc faults, MC4-style connectors, combiners, fuses and DC isolators', 'Racking, roofs, ground mounts and after-the-storm inspections']
}, {
  number: '03',
  title: 'Power Conversion: String Inverters, Micros & Optimizers',
  meetings: '28 cards · 6 WS',
  promise: 'Prove whether it’s the inverter, the DC side or the grid.',
  band: 'bg-vol-3',
  ink: 'text-white',
  contents: ['The Inverter Truth Test: DC in, AC out, grid OK, comms up', 'Isolation, grid-voltage, frequency and overtemperature faults', 'Error code families by platform (verify in the current manual)', 'Micros not reporting, optimizers stuck in safe mode, rapid shutdown', 'Reversed CTs, frequent tripping, voltage rise and wrong grid-code settings']
}, {
  number: '04',
  title: 'Batteries, Hybrid & Off-Grid Systems',
  meetings: '28 cards · 6 WS',
  promise: 'State of charge, BMS and backup faults, diagnosed safely.',
  band: 'bg-vol-4',
  ink: 'text-white',
  contents: ['The Battery Four: state of charge, voltage, temperature, communication', 'Not charging, not discharging, BMS comms, imbalance and capacity loss', 'Hybrid inverters that won’t switch to backup in an outage', 'MPPT and PWM controllers, generators and lead-acid banks', 'RVs, cabins and solar pumping — plus the stop signs for swelling, heat and smoke']
}, {
  number: '05',
  title: 'Install, Commission & Code Compliance',
  meetings: '26 cards · 7 WS',
  promise: 'Install it once, pass the first inspection, hand it over clean.',
  band: 'bg-vol-5',
  ink: 'text-white',
  contents: ['The Code Column Method: one check, four countries', 'String design for the coldest morning, conductors, protection, grounding', 'The Commissioning Proof Pack with acceptance values', 'Inspector, utility approval and the customer handover', 'Audit someone else’s install before you take it over']
}, {
  number: '06',
  title: 'Maintain, Report & Warranty',
  meetings: '24 cards · 8 WS',
  promise: 'Close the call with paperwork that gets signed and claims that get paid.',
  band: 'bg-vol-6',
  ink: 'text-white',
  contents: ['Annual inspections for grid-tied, battery, off-grid and commercial systems', 'Service reports the customer understands and records the next tech needs', 'Repair estimates and the Fix-Replace-Upgrade Line', 'The Claim-Proof Four: proof, serials, logs and photos for every claim', 'Orphaned systems, maintenance plans, callbacks and worried customers']
}];
export function Tomes() {
  return <section aria-labelledby="tomes-heading" className="topo-light w-full bg-paper" data-id="element-386" data-mp="3va4jn0d3ix32">
      <div className="mx-auto max-w-6xl px-5 py-14 sm:py-20" data-id="element-387" data-mp="3c5rkylzwrbc4">
        <div className="text-center" data-id="element-388" data-mp="379u6kl87gf1z">
          <p className="eyebrow text-ember-deep" data-id="element-389" data-mp="376ogp3rr5957">The path of the energy and the visit</p>
          <h2 id="tomes-heading" className="trail-underline mt-3 font-display text-[34px] leading-tight text-pine sm:text-6xl" data-id="element-390" data-mp="3lz03g2jklt6p">
            Inside the pack — six volumes
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-pine-soft" data-id="element-391" data-mp="3pzah81dltnw4">
            The method first, then each zone in the order the energy flows —
            array, conversion, storage — then install and code, and finally the
            paperwork that closes the call. Every volume stands on its own: open
            the one you need on this job.
          </p>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-392" data-mp="2akmgczwn5hrq">
          {tomes.map(tome => <article key={tome.number} className="flex flex-col overflow-hidden rounded-2xl border border-paper-dark bg-white shadow-card" data-id="element-393" data-mp="25lryq1aetz97">
              <div className={`relative overflow-hidden ${tome.band}`} data-id="element-394" data-mp="pzobr9rie6c9">
                <TopoLines className={`pointer-events-none absolute -right-6 -top-8 h-28 w-28 opacity-20 ${tome.ink}`} data-id="element-395" data-mp="bajr7lx8rq0z" />
                <div className="relative flex items-center justify-between px-5 py-3.5" data-id="element-396" data-mp="2awsx8zt70c5">
                  <span className={`font-mono text-[11px] font-bold uppercase tracking-[1.5px] opacity-90 ${tome.ink}`} data-id="element-397" data-mp="2d9hw63ziayp">
                    Volume {tome.number} · {tome.meetings}
                  </span>
                  <span className={`font-display text-4xl leading-none ${tome.ink}`} data-id="element-398" data-mp="3ti99blsvb9r0">
                    {tome.number}
                  </span>
                </div>
              </div>

              <div className="trail-card flex flex-1 flex-col p-6 pt-5" data-id="element-399" data-mp="1rqcwm8uyrtun">
                <h3 className="font-display text-2xl leading-tight text-pine" data-id="element-400" data-mp="1q8o1zjt17l14">
                  {tome.title}
                </h3>
                <p className="mt-1.5 text-sm text-pine-soft" data-id="element-401" data-mp="1l9bfj062ofz2">{tome.promise}</p>
                <ul className="mt-4 grid gap-2 border-t border-paper-dark pt-4" data-id="element-402" data-mp="1ga89pdi9q5q1">
                  {tome.contents.map(item => <li key={item} className="flex gap-2.5 text-[14px] leading-snug text-pine" data-id="element-403" data-mp="1bcgheidpohlb">
                      <span className="mt-[6px] h-2 w-2 flex-none rounded-full bg-ember" data-id="element-404" data-mp="28y458ew3prl8" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}